// extracted by mini-css-extract-plugin
export default {"wrap":"index_wrap_GIC8D clearfix","box":"index_box_Saue9"};